import { useState } from "react";

export function useCRMSelection() {
  const [selectedClientIds, setSelectedClientIds] = useState<string[]>([]);
  const [selectedContactIds, setSelectedContactIds] = useState<string[]>([]);

  const handleSelectAllClients = (
    event: React.ChangeEvent<HTMLInputElement>,
    filteredClients: any[],
  ) => {
    setSelectedClientIds(event.target.checked ? filteredClients.map((c) => c._id) : []);
  };

  const handleSelectClient = (
    event: React.ChangeEvent<HTMLInputElement>,
    clientId: string,
  ) => {
    if (event.target.checked) {
      setSelectedClientIds((prev) => [...prev, clientId]);
    } else {
      setSelectedClientIds((prev) => prev.filter((id) => id !== clientId));
    }
  };

  const handleSelectOneContact = (
    event: React.ChangeEvent<HTMLInputElement>,
    contactId: string,
  ) => {
    if (event.target.checked) {
      setSelectedContactIds((prev) => [...prev, contactId]);
    } else {
      setSelectedContactIds((prev) => prev.filter((id) => id !== contactId));
    }
  };

  return {
    selectedClientIds,
    setSelectedClientIds,
    selectedContactIds,
    setSelectedContactIds,
    handleSelectAllClients,
    handleSelectClient,
    handleSelectOneContact,
  };
}
